import { type VariablesOf, graphql } from "@/data-access/graphql";
import { NewsAlertFragment } from "../fragments/news-alerts-fragments";

export type NewsAlertSortOrder = NonNullable<
  VariablesOf<
    typeof CreateNewsAlertMutation
  >["input"]["sections"][number]["sortOrder"]
>;

export type NewsAlertScheduleFrequency = NonNullable<
  VariablesOf<typeof CreateNewsAlertMutation>["input"]["newsAlert"]["sendOn"]
>;

export const NewsAlertsQuery = graphql(
  `
  query NewsAlerts($filters: NewsAlertFilter, $pagination: OffsetPaginationInput) {
    newsAlerts(filters: $filters, pagination: $pagination) {
      ... on NewsAlertType {
        ...NewsAlertFragment
      }
    }
  }
`,
  [NewsAlertFragment],
);

export const CreateNewsAlertMutation = graphql(
  `
  mutation CreateNewsAlert($input: CreateNewsAlertInput!) {
    createNewsAlert(input: $input) {
      ... on NewsAlertType {
        ...NewsAlertFragment
      }
      ... on OperationInfo {
        __typename
        messages {
          field
          message
          code
        }
      }
    }
  }
  `,
  [NewsAlertFragment],
);

export const DeleteNewsAlertMutation = graphql(`
  mutation DeleteNewsAlert($newsAlertId: ID!) {
    deleteNewsAlert(newsAlertId: $newsAlertId) {
      ... on SuccessResponse {
        __typename
        message
      }
      ... on OperationInfo {
        __typename
        messages {
          message
          kind
        }
      }
    }
  }
`);

export const GenerateNewsAlertPreviewMutation = graphql(`
  mutation GenerateNewsAlertPdfPreview($input: GenerateNewsAlertPdfPreviewInput!) {
  generateNewsAlertPdfPreview(input: $input) {
    ... on NewsAlertPDFPreviewResponse {
      __typename
      url
    }
    ... on OperationInfo {
      __typename
      messages {
        code
        field
        message
      }
    }
  }
}
`);

export const UpdateNewsAlertMutation = graphql(
  `
  mutation UpdateNewsAlert($input: UpdateNewsAlertInput!) {
    updateNewsAlert(input: $input) {
      ... on NewsAlertType {
        ...NewsAlertFragment
      }
      ... on OperationInfo {
        __typename
        messages {
          field
          message
          code
        }
      }
    }
  }
  `,
  [NewsAlertFragment],
);

/**
 * String representation of the UploadNewsAlertLogo mutation for multipart uploads
 */
export const UploadNewsAlertLogoMutationString = `
  mutation UploadNewsAlertLogo($input: UploadNewsAlertLogoInput!) {
    uploadNewsAlertLogo(input: $input) {
      ... on NewsAlertLogoType {
        __typename
        id
        logoUrl
        logo {
          __typename
          height
          name
          size
          url
          width
        }
      }
      ... on OperationInfo {
        __typename
        messages {
          field
          message
          code
        }
      }
    }
  }
`;
